<template>
    <div class="sidebar" :class="{ 'sidebar-show': sidebarShow }" @click="close" v-clickoutside="close">
        <div class="sidebar-title">{{ $route.params.bookName || $route.params.drugName }}</div>
        <div class="sidebar-body">
            <perfect-scrollbar ref="sidebar" :options="{ suppressScrollX: true }">
                <u-catalogue v-if="$route.name == 'bookDetail'" :bookId="$route.params.bookId"
                    :bookName="$route.params.bookName" />
                <div v-else class="drug-name-list">
                    <a @click="onDrugItem(index)" class="d-item" :class="{ active: index == drugInfoListIndex }"
                        v-for="(item, index) in drugInfoList" :key="item.id">
                        {{ item.zhaiLu }}: {{ item.mingCheng }}
                        <i v-if="item.geJiaLS">论</i>
                    </a>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Clickoutside from 'element-ui/src/utils/clickoutside';

export default {
    directives: { Clickoutside },
    computed: {
        ...mapGetters(['sidebarShow', 'drugInfoList', 'drugInfoListIndex', 'besideRoll']),

    },
    watch: {
        besideRoll() {
            this.goto();
        }
    },
    data() {
        return {

        }
    },
    methods: {
        close() {
            this.$store.commit('setSidebarShow', false);
        },
        onDrugItem(index) {
            // this.drugInfoList.forEach(i => i.active = false)
            // item.active = true;
            this.$store.commit("drugInfoListIndex", index)
        },
        goto() {
            setTimeout(() => {
                if (this.$refs.sidebar) {
                    let node = this.$refs.sidebar.$el.querySelector('.active');
                    this.$refs.sidebar.$el.scrollTop = node.offsetTop;
                }
            }, 500)
        }
    },
    created() {
    },
}
</script>

<style lang="scss" scoped>
.sidebar {
    ul {
        padding-left: 15px;
        line-height: 2em;
    }

    .drug-name-list {
        .d-item {
            display: block;
            margin-right: 15px;
            margin: 5px 0;

            &.active {
                background: #42b883;
                color: #fff !important;
                border-radius: 3px;
            }

            i {
                font-size: 12px;
                font-style: normal;
                border-radius: 100%;
                color: #fff;
                background: #f00;
                border: 1px solid #f00;
                position: absolute;
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
            }
        }
    }
}
</style>
